export default "__VITE_ASSET__D2s38ocd__"